module.exports = __webpack_public_path__ + "img/logo-carcelen.308a7cfe.png";